import { jsx } from "react/jsx-runtime";
import { useTidalFormBridge } from "../../utils/useTidalFormBridge.js";
import {
  DurationInput as DurationInputBase
} from "../../../../components/DurationInput/index.js";
const defaultComponentValue = null;
function DurationInput(props) {
  const {
    placeholder,
    durationInputProps,
    initialValue = defaultComponentValue,
    validateOn = "change",
    debounce = null,
    durationFormat = "hh:mm",
    ...bridgeOptions
  } = props;
  const {
    config: { label, name, testId = "durationInput-root" },
    fieldInfo: {
      errorOrHelperText,
      field: { visible },
      fieldDisabled,
      fieldHasError,
      onBlur,
      onChange,
      onFocus,
      showErrorAccent,
      value
    }
  } = useTidalFormBridge({
    ...bridgeOptions,
    debounce,
    validateOn,
    initialValue
  });
  if (!visible) return null;
  return /* @__PURE__ */ jsx(
    DurationInputBase,
    {
      label,
      format: durationFormat,
      slotProps: {
        ...durationInputProps?.slotProps,
        textfield: {
          ...durationInputProps?.slotProps?.textfield,
          onBlur,
          onFocus,
          placeholder
        }
      },
      testId,
      disabled: fieldDisabled,
      error: showErrorAccent && fieldHasError,
      helperText: errorOrHelperText,
      name,
      onChange,
      value,
      "data-tidal-form-field-name": bridgeOptions.name,
      ...durationInputProps
    }
  );
}
export {
  DurationInput
};
//# sourceMappingURL=DurationInput.js.map
